import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const canUndoReviseProduct = map.useCanUndoReviseProduct()

    if (! canUndoReviseProduct) {
        return null
    }

    return {
        key: 'undo-revise-product',
        label: '撤销修订制品',
        onClick: () => map.cmdUndoReviseProduct(),
    }
}
